import { LOCALES } from '../locales'

export const english_messages = {
	[LOCALES.ENGLISH]: {
		//loading
		loadingP1: 'loa',
		loadingP2: 'ding',

		internalVacanciesTitle: 'Internal Vacancies',
		internalChannelTitle: 'Internal Communication',

		mainMenuFeed: 'My Feed',
		mainMenuProfile: 'My Profile',
		mainMenuMoment: 'My Moment',
		mainMenuVacancies: 'My Vacancies',
		mainMenuCompany: 'For Companies',
		mainMenuSearch: 'Search persons and companies',
		mainMenuSeeMore: 'See more',

		dropdownCompany: 'My Company',
		dropdownLogout: 'Log out',
		dropdownProfile: 'Edit Profile',

		/** WheelCompany */
		seeMore: 'See more',
		myBusiness: 'My Business',
		peopleAnalytics: 'People Analytics',
		recruitmentAndSelection: 'Ombudsman',
		learning: 'Learning',
		trainings: 'Trainings',
		performanceAnalysis: 'Performance Analysis',
		historicEvaluations: 'Historico de Evaluaciones',
		salariesAndBenefits: 'Salaries & Benefits',
		careerPlan: 'Career Plan',
		cultureAnalysis: 'Culture Analysis',
		professionalDevelopment: 'Professional Development',
		outplacement: 'Outplacement',

		//Employee Profile Edit
		profileError: 'Required field',
		admissionDocuments: 'Documentos de Admisión',
		professionalHistoric: 'Professional History',
		documentsTitle: 'Documents',
		purpose: 'Purpose',
		formation: 'Formation',
		climeAndCulture: 'Climate & Culture',
		salary: 'Salary',
		habilities: 'Skills',
		motivacions: 'Motivations',
		performance: 'Performance',
		training: 'Training',

		/** Assessment / WithMeGrow */
		competencyTest: 'Competency Test',
		questionsDescription:
			'Here you will find the questions to assess your skills development level. We ask that you select your degree of agreement or disagreement with each statement.',
		responseOptions: 'Response options:',
		veryDisagreeable: 'Strongly disagree',
		inDisagreement: 'Disagree',
		neutral: 'Neutral',
		iAgree: 'Agree',
		iAgreeVeryMuch: 'Strongly agree',
		tryNotToRespondInNeutral: 'Try not to respond neutrally',
		answerHonestly: 'Answer honestly',
		itsLessThan25Minutes: 'Takes less than 25 minutes',
		saveAndFollow: 'Save and Continue',
		conclude: 'Conclude',
		progress: 'Progress',
		steps: '/16 Steps',
		back: 'Back',
		next: 'Next',
		fortresses: 'Strengths',
		improvementOpportunities: 'Opportunities for Improvement',
		readMore: 'read more',
	},
}
